import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { resetAddressState } from '@store/modules/address';

@Injectable({
  providedIn: 'root'
})
export class AddressFacadeService {
   readonly #store = inject(Store);

   reset() {
    this.#store.dispatch(resetAddressState());
   }
}
